import { all } from "redux-saga/effects";
import {
    addPresetWatcher,
    editPresetWatcher,
    togglePresetActiveStateWatcher,
    toggleCertifiedPresetWatcher
} from "./addPreset.saga";
import { getSubsidiariesWatcher } from "./getSubsidiaries.saga";
import { getPresetsWatcher, getPresetWatcher } from "./getPresets.saga";

export default function* rootSaga() {
    yield all([
        getSubsidiariesWatcher(),
        getPresetsWatcher(),
        addPresetWatcher(),
        getPresetWatcher(),
        editPresetWatcher(),
        togglePresetActiveStateWatcher(),
        toggleCertifiedPresetWatcher()
    ]);
}
